module.exports = __webpack_public_path__ + "img/05-villas.d026aeee.jpg";